export const ZIndexPanelCloseButton = {
  panelCloseButton: '1000',
  toastCloseButton: '1200',
};

export const ZIndexEvidenceCard = 1500;

export const ZIndexDrawer = {
  chatDrawer: '1500',
};
